import { ICondition } from '../../../../vendor_core/core/src/states/State';
import SpinModel from "../../../../vendor_core/core/src/model/SpinModel";

export class VOEHasWinCondition implements ICondition {
  public check(): boolean {
    return (SpinModel.hasWinnings() && SpinModel.winsData.length > 0)
  }      
}
